module.exports = __webpack_public_path__ + "static/closed-33af3a553264bb503c697172727d6bab.jpg";